import React, { PropsWithChildren, ReactNode } from 'react';
import { ApolloError } from '@apollo/client';
import { Typography } from '@mui/material';

interface Props {
  isLoading: boolean;
  fallBack?: ReactNode;
  error?: ApolloError | null;
}

export const RenderWithFallback = ({
  children,
  isLoading,
  error = null,
  fallBack = null,
}: PropsWithChildren<Props>) => {
  if (error) return <Typography>Error: {error?.message}</Typography>;

  return <>{isLoading ? fallBack : children}</>;
};
